import React from 'react';
import './Footer.css';
import { useNavigate } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();

  return (
    <div>
      <footer className="d-flex justify-content-around foot">
        <i className="fas fa-home footele" onClick={() => navigate('/', { replace: true })}></i>
      </footer>
    </div>
  );
}

export default Footer;
